import React from 'react';
import ReactDOM from 'react-dom';
import App from './Main';
import './react.css';

ReactDOM.render(<App />, document.getElementById('root'));
